import axios from 'axios';
import { deleteCookie } from '@/utils/cookie'
import { join } from 'lodash';
import { ParentSpec, ProductSchema as ProductSchemaTemu } from '@/views/platformTemplate/temu/types';
import { Address } from '@/store/userInfo';
/**
 * 代表一个成品
 */
export type SearchProduct = {
  caizhi: string[],
  code: string,
  color: string[],
  cus_code_json: string | { [key: string]: string },
  customer_design_id: number,
  price: string,
  pro_code: string,
  product_id: number,
  size: string[][]
  thumb: string,
  time: string,
  title: string,
}

export type AddProductData = {
  customer_design_id: number,
  quantity: number,
  color: string,
  size: string,
  caizhi: string,
  order_id?: number | string,
  sku_local?: string,
}

/**
 * 代表一个效果图
 */
export type DesignImage = {
  /** 原图URL */
  url_img: string,
  /** 缩略图URL */
  url_img_thumb: string,
  /** 图片比例是否为1:1 true为1:1，false代表3:4*/
  url_img_11: "true" | "false",
  is_ai_drawing: number,
}


class HttpRequest {
  defaults: Object
  constructor(options: any) {
    this.defaults = {
      baseUrl: ''
    }
    this.defaults = Object.assign(this.defaults, options)
  }
  interceptors(install: any) {
    install.interceptors.request.use(
      (config: any) => {
        const token = localStorage.getItem('token') || '';
        if (token) {// 判断是否存在token，如果存在的话，则每个http header都加上token
          config.headers.token = `${token}`;
        }
        config.withCredentials = true;
        return config;
      },
      (err: any) => {
        return Promise.reject(err);
      }
    );
    install.interceptors.response.use(
      (res: any) => {
        const { data, status } = res;
        const { code } = data || {}
        if (code == 500) {
          // localStorage.removeItem('token')
          // deleteCookie('PHPSESSID')
        }
        return data;
      },
      (err: any) => {
        return Promise.reject(err);
      }
    );
  }
  request(options: any) {
    options = Object.assign(this.defaults, options || {});
    const instance = axios.create(options)
    this.interceptors(instance)
    return instance
  }
}
const request = new HttpRequest({
  timeout: 50000,
  withCredentials: true, // 允许携带cookie
});
const http = request.request({});


/**
 * 注册账号
 * @export
 * @param {Object} params - 
 * @param {Object} params.name - 用户名
 * @param {Object} params.password - 密码
 * @returns
 */
export async function register(params: any) {
  return await http.post('/user/create', params);
}

/**
 * 账号登录
 * @export
 * @param {Object} params - 
 * @param {string} params.name - 用户名
 * @param {string} params.password - 密码
 * @returns
 */
export async function login(params: any) {
  return await http.post('/index.php?route=vapi/account/login', params)
}

export async function saveDesign(params: any) {
  return await http.post('/index.php?route=apipc/diy/save_custom', params)
}
/**
 * 账号登出
 */
export async function login_out({ token = '' }) {
  return await http.post('/index.php?route=vapi/account/logout', { token });
}

/** 会员中心头部导航菜单（后端树形结构） */
export async function getMemberMenus(params?: Record<string, unknown>) {
  return await http.post('/index.php?route=api/menu/getMemberMenus', params ?? {});
}

/**
 * 获取用户信息
 * @export
 * @param {Object} params - 
 * @param {string} [params.userId] - 用户id
 * @returns
 */
export async function userInfo(params: any) {
  return await http.post('/index.php?route=vapi/user/userinfo', params);
}
/**
 * 获取个人详细资料
 * @export
 * @param {Object} params - 
 * @param {string} [params.userId] - 用户id
 * @returns
 */
export async function userDetail(params: any) {
  return await http.post('/index.php?route=vapi/user/userdetail', params);
}
/**
 * 我的订单
 * @export
 * @param {Object} params - 
 * @param {string} [params.page] - 分页参数
 * @param {string} [params.os] - 订单类别 0:全部 daifa待发 daishou待收 yiwancheng已完成 shouhou售后 daifu待付
 * @param {string} [params.key] - 订单号
 * @returns
 */
export async function getOrderDetail(params: any) {
  return await http.post('/api/member/order', params);
}
/**
 * 订单管理
 * @export
 * @param {Object} params - 
 * @param {string} [params.page] - 分页参数
 * @param {string} [params.os] - 订单类别 0:全部 daifa待发 daishou待收 yiwancheng已完成 shouhou售后 daifu待付
 * @param {string} [params.key] - 订单号
 * @returns
 */
export async function getNewOrderDetail(params: any) {
  return await http.post('/index.php?route=vapi/order/orderNew2', params);
}
/**
 * 订单类型
 * @export
 * @param {Object} params - 
 * @param {string} [params.page] - 分页参数
 * @param {string} [params.os] - 订单类别 0:全部 daifa待发 daishou待收 yiwancheng已完成 shouhou售后 daifu待付
 * @param {string} [params.key] - 订单号
 * @returns
 */
export async function getOrderType(params: any) {
  return await http.post('/index.php?route=vapi/order/getOrdertype', params);
}
/**
 * 订单进度
 * @export
 * @param {Object} params - 
 * @param {string} [params.page] - 分页参数
 * @param {string} [params.os] - 订单类别 0:全部 daifa待发 daishou待收 yiwancheng已完成 shouhou售后 daifu待付
 * @param {string} [params.key] - 订单号
 * @returns
 */
export async function getOrderOperation(params: any) {
  return await http.post('/index.php?route=vapi/order/orderOperation', params);
}
/**
 * 生产图列表
 * @export
 * @param {Object} params - 
 * @param {string} [params.page] - 页码
 * @param {string} [params.page_size] - 页数
 * @param {string} [params.product_code] - 商品编码
 * @returns
 */
export async function getProductDraw_list(params: any) {
  return await http.post('/index.php?route=customer/prod_drawing/list', params);
}
/**
 * 删除生产图
 * @export
 * @param {number} [id] - 图片id
 * @returns
 */
export async function delPrpductDraw(id: number) {
  return await http.post('/index.php?route=customer/prod_drawing/del', { id });
}
/**
 * 上传生产图（单图片）
 * @export 
 * @param {any} [file] - 图片文件
 * @returns
 */
export async function uploadProduct_Draw(file: any) {
  return await http.post('/index.php?route=customer/prod_drawing/upload', file);
}
/**
 * 大图分片上传（检查分片）
 * @export 
 * @param {Object} params - 
 * @param {file}   [params.file_md5] - 文件
 * @param {Number} [params.file_size] - 文件大小
 * @returns
 */
export async function uploadChunk_Img(params: any) {
  return await http.post('/index.php?route=customer/prod_drawing/checkUpload', params);
}
/**
 * 大图分片上传（上传单个分片）
 * @export 
 * @param {Object} params - 
 * @param {file}   [params.file_md5] - 文件
 * @param {Number} [params.file_size] - 文件大小
 * @param {Number} [params.chunk_index] - 分片序号
 * @returns
 */
export async function uploadSingle_Img(params: any) {
  return await http.post('/index.php?route=customer/prod_drawing/uploadChunk', params);
}
/**
 * 大图分片上传（合并分片）
 * @export 
 * @param {Object} params - 
 * @param {file}   [params.file_md5] - 文件
 * @param {Number} [params.file_size] - 文件大小
 * @param {Number} [params.chunks_total] - 分片总数
 * @param {String} [params.file_name] - 文件名
 * @returns
 */
export async function uploadMerge_Img(params: any) {
  return await http.post('/index.php?route=customer/prod_drawing/mergeUpload', params);
}
/**
/**
 * 我的购物车
 * @export
 * @param {Object} params - 
 * @returns
 */
export async function getCartInfoData(params: any) {
  return await http.post('/index.php/?route=vapi/carts/index', params);
}
/**
 * 购物车删除
 * @export
 * @param {Object} params - cid
 * @returns
*/
export async function deleteCartItem(params: any) {
  return await http.post('/index.php/?route=vapi/carts/delcart', params);
}
/**
 * 上传图片
 * @export
 * @param {Object} [params] - 
 * @param {string} [params.type] - product user step
 * @returns
 */
export async function upload(params: any) {
  return await http.post('/upload', { params });
}
/**
* 修改用户信息
* @export
* @param {Object} [params] - 
* @param {string} [params.name] - product user step
* @param {string} [params.avatar] - product user step
* @param {string} [params.sign] - product user step
* @returns
*/
export async function userEdit(params: any) {
  return await http.post('/user/edit', params);
}
/**
* 获取模特图信息
* @export
* @param {Object} [params] - 
* @param {string} [params.sku] - 
* @returns
*/
export async function getModelInfo(params: any): Promise<any> {
  return await http.post('/index.php?route=apipc/diy/newpinban', params);
}
/**
* 获取虚线图信息
* @export
* @param {Object} [params] - 
* @param {string} [params.sku] - 
* @returns
*/
export async function getXxInfo(params: any): Promise<any> {
  return await http.post('/index.php?route=apipc/diy/get_pro_model', params);
}
/**
 * 订单支付
 * @export
 * @param {Object} [params]
 * @param {integer} [params.orderid]
 * @param {integer} [params.type] 1余额支付 2支付宝支付
 * @param {string} [params.token]
 */
export async function getPingpayOrder({ orderid = 0, type = 1, token = '' } = {}): Promise<any> {
  return await http.post('/api/order/pingpayOrder', { orderid, type, token })
}
/**
 *  登录客户信息
 * @export
 * @param {Object} [params]
 * @param {integer} [params.orderid]
 * @param {integer} [params.type] 1余额支付 2支付宝支付
 * @param {string} [params.token]
 */
export async function getCustomerInfo_st({ customer_id = 1645, origin = "https://mszxdz.com", store_id = '123' } = {}): Promise<any> {
  return await http.post('/index.php?route=apipc/v1/diy/getCustomerInfo', { customer_id, origin, store_id })
}
/**
 *  获取3D模型和对应的素材图片
 * @export
 * @param {Object} [params]
 * @param {integer} [params.orderid]
 * @param {integer} [params.type] 1余额支付 2支付宝支付
 * @param {string} [params.token]
 */
export async function getheipian_st({ customer_id = 1645, origin = "https://mszxdz.com", store_id = 123, editionnum = 1, pid = '', size = 'S', sku = 'R0026AB-A' } = {}): Promise<any> {
  return await http.post('/index.php?route=apipc/v1/diy/getheipian', { customer_id, origin, store_id, editionnum, pid, size, sku })
}
/**
 * 获取记录
 * @param {Object} params -
 * 
 */
export async function getDesignRecord({ design_id, product_id }) {
  return await http.post('/index.php?route=apipc/diy/get_design_record', { design_id, product_id })
}
export async function uploadSingleImg({ img }) {
  return await http.post('/uploadImg.php', { img })
}
export async function modifyCustom({ cid, m_imgList }) {
  return await http.post('/index.php?route=apipc/v1/diy/modifyCustom', { cid, m_imgList })
}
/**
 *  3d模特对位参数
 * @export
 * @param {Object} [params]
 * @param {integer} [params.orderid]
 * @param {integer} [params.type] 1余额支付 2支付宝支付
 * @param {string} [params.token]
 */
export async function threeModelConfig_st({ customer_id = 1645, origin = "https://mszxdz.com", store_id = 123, pid = '', three_model_config = '', read_save = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=apipc/v1/diy/threeModelConfig', { customer_id, origin, store_id, pid, three_model_config, read_save })
}

/**
 * 取消
 * @export
 * @param {Object} [params]
 * @param {integer} [params.orderid]
 * @param {integer} [params.type] 1余额支付 2支付宝支付
 * @param {string} [params.token]
 */
export async function cancelProduct({ orderid = '', order_status = 14, token = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/order/updateOrderStatus', { orderid, order_status, token })
}


/**
 * 订单申请退货、退款
 * @export
 * @param {Object} [params]
 * @param {integer} [params.ordernum] 订单号
 * @param {integer} [params.reason] 申请原因
 * @param {integer} [params.tui_type] 5申请退货 7申请退款 
 * @param {string} [params.token]
 */
export async function getTuiOrder({ ordernum = '', reason = '', tui_type = 7, token = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/order/tuiOrder', { ordernum, reason, tui_type, token })
}
/**
 * 查看物流
 * @export
 * @param {Object} [params]
 * @param {integer} [params.ordernum] 订单号
 * @param {string} [params.token]
 */
export async function seeWuliu({ ordernum = '', token = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/order/see_wuliu', { ordernum, token })
}
/**
 * 订单管理新 查看物流
 * @export
 * @param {Object} [params]
 * @param {integer} [params.ordernum] 订单号
 * @param {string} [params.token]
 */
export async function queryItsTrack({ waybillNo = '' }): Promise<any> {
  return await http.get('/index.php?route=customer/temusemi/queryItsTrack', { params: { waybillNo } })
}
/**
 * 确认订单操作
 * @export
 * @param {Object} [params]
 * @param {integer} [params.orderid] 订单id
 * @param {integer} [params.ordernum_other] 第三方订单编号
 * @param {string} [params.token]
 */
export async function orderSure({ deliveryAddressId = '', orderid = '', ordernum_other = '', token = '', factoryid = '', force = 0, total_code = '', total_number = 0, shipping_code = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/order/orderSure', { deliveryAddressId, orderid, ordernum_other, token, factoryid, force, total_code, total_number, shipping_code })
}

/**
 * 订单待付款状态支付
 *
*/
export async function unpaidPayment({ orderid = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/order/unpaidPayment', { orderid })
}

export async function orderSureNew({ orderid = '', ordernum_other = '', token = '', factoryid = '', force = 0, shipping_method = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/order/orderSureNew', { orderid, ordernum_other, token, factoryid, force, shipping_method })
}

/**
 * 订单合并产品条形码
 * @export
 * @param {Object} [params]
 * @param {integer} [params.orderid] 订单id
 * @param {string} [params.token]
 */
export async function mergeSku({ lan_id = '', order_status = 0 } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/order/merge_sku', { lan_id, order_status })
}
/**
 * 我的商品
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function getMyProduct({ page = 1, key = '', cat = '', pro_code = '', add_code = '', remark = '', add_sku = '', token = '', page_size = 20, platform = '', publish = '', design_id = '', source_customer_id = '', material_url = '', start_date = '', end_date = '', cate_id = '', source = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/design/index', { page, key, cat, pro_code, add_code, remark, add_sku, token, page_size, platform, publish, design_id, source_customer_id, material_url, start_date, end_date, cate_id, source })
}
/**
 * 搜索成品
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function getMyProductt({ token = '', pro_code = '' } = {}): Promise<any> {
  return http.post('/index.php?route=vapi/design/search', { token, pro_code })
}
/**
 * 订单添加设计成品
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function getMyProducss({ token = '', PHPSESSID = '', order_id = '', other_id = '', customer_design_id = '', quantity = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/order_product/addOrderProduct', { token, PHPSESSID, order_id, other_id, customer_design_id, quantity })
}
/**
 * 订单拆分
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function getMyProdsplit({ token = '', PHPSESSID = '', order_id = '', other_id = '', split_data = [] } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/order_product/split', { token, PHPSESSID, order_id, other_id, split_data })
}
/**
 * 导入页面获取导入记录和模板地址的接口
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function toleadItems(token = '', id = '', original_name = '', file_path = '', error_file_path = '', remark = '', created_by = '', created_at = '') {
  return await http.get('/index.php?route=vapi/order/getTemplate', {
    params: { token, id, original_name, file_path, error_file_path, remark, created_by, created_at }
  });
}
export async function getImportTemplateList(token = '', id = '', original_name = '', file_path = '', error_file_path = '', remark = '', created_by = '', created_at = '') {
  return await http.get('/index.php?route=vapi/order/getTemplate', {
    params: { token, id, original_name, file_path, error_file_path, remark, created_by, created_at }
  });
}
/**
 *  上传的接口
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function uploadingItme(file: FormData, token = '') {
  return await http.post('/index.php?route=vapi/order/importOrder',
    {
      file,
      token
    });
}
/**
 * 加入购物车
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function addProductToCart({ pid = '', token = '', cid = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/design/designCart', { pid, token, cid })
}
/**
 * 获取商品的客户编码
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function getCustomerCode({ cid = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/design/getCustomerCode', { cid })
}
/**
 * 获取商品的客户编码2
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function getCustomerCode2({ cid = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/design/getCustomerSku', { cid })
}
/**
 * 保存商品的客户编码
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function saveCustomerCode({ cid = '', code_json = {}, sku_json = {} } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/design/saveCustomerCode', { cid, code_json, sku_json })
}
/**
 * 购物车获取价格接口
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function getCartPrice({ pid = '', num = 1, cid = '', guige = {}, attribute = [], token = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/design/getCartPrice', { pid, num, cid, guige, attribute, token })
}
/**
 * 商品列表加入购物车
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function clickButtonaddProductToCart({ pid = '', num = 1, cid = '', code = '', can = {}, attribute = '', token = '', is_paynow = 0 } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/design/addCart', { pid, num, cid, code, can, attribute, token, is_paynow })
}
/**
 * 商品列表删除商品
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function productListDelete({ cid = '', token = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/design/delete', { cid, token })
}

export async function productDeleteShared({ cid = '', token = '' } = {}): Promise<any> {
  return http.post('/index.php?route=vapi/design/cancelShare', { cid, token })
}

/**
 * 关联第三方店铺
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function getOrderShopRelation({ shop_name = '', shop_token = '', shop_secret = '', type = 0, shop_id = '', act = '', page = 1, shop_category = 0 } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/shop/orderShopRelation', { shop_name, shop_token, shop_secret, type, shop_id, act, page, shop_category })
}
/**
 * 子账户列表
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function getChildAccount({ page = 1 } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/user/childrenAccountList', { page })
}
/**
 * 创建子账户
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function addChildAccount({ uname = '', pwd = '', remarks = '' } = {}): Promise<any> {
  return await http.post('/api/member/childaccount_update', { uname, pwd, remarks })
}
/**
 * 删除子账户
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function delChildAccount({ did = '' } = {}): Promise<any> {
  return await http.post('/api/member/childaccount_del', { did })
}
/**
 * 编辑子账户
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function editChildAccount({ saveid = '', pwd = '', remarks = '' } = {}): Promise<any> {
  return await http.post('/api/member/childaccount_edit', { saveid, pwd, remarks })
}
/**
 * 地址列表
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function getAddressList({ page = 1 } = {}): Promise<{
  code,
  msg,
  data: {
    data: Address[],
    page: number,
    recordsTotal: number,
    recordsFiltered: number
  },
}> {
  return await http.post('/index.php?route=vapi/address/getAddressList', { page })
}

export interface EditAddressForm {
  saveid?: number,
  country: number,
  province: number,
  city: number,
  xian: number,
  zipcode: string
  address_detail: string,
  uname: string,
  tel: string,
  city_name: string,
}

/**
 * 新增或修改地址
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function addAndUpdateAddress(form: EditAddressForm): Promise<any> {
  return http.post('/index.php?route=vapi/address/addAndUpdateAddress', form)
}

/**
 * 新增地址
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function addAddress({ saveid = '', province = '', city = '', xian = '', zipcode = '', address_detail = '', uname = '', tel = '', country = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/address/addAddress', { saveid, province, city, xian, zipcode, address_detail, uname, tel, country })
}

/**
 * 删除地址
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function delAddress({ aid = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/address/delAddress', { aid })
}
export async function delPdf(): Promise<any> {
  return await http.post('/index.php?route=checkout/checkout/delPdf')
}
/**
 * 省市区获取
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function getArea({ aid = 0 } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/address/getArea', { aid })
}
/**
 * 全球省市区获取
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function getGlobalArea({ aid = 0, countryId = 0, zid = 0, cid = 0 } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/address/getGlobalArea', { aid, countryId, zid, cid })
}
/**
 * 登录日志
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function loginLog({ page = 1 } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/user/loginLog', { page })
}
/**
 * 充值
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function rechargeOrder({ money = 0, type = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/order/rechargeOrder', { money, type })
}
export async function isRechargeOrderPaid({ orderId = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=extension/payment/wechat_pay/isRechargeOrderPaid', { orderId })
}
/**
 * 充值记录
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function rechargeList(): Promise<any> {
  return await http.post('/index.php?route=vapi/bill/rechargeList')
}

export async function myBill(params: any): Promise<any> {
  return await http.post('/index.php?route=vapi/bill/myBill', params)
}
export async function myBillDetails(params: any): Promise<any> {
  return await http.post('/index.php?route=vapi/bill/myBillDetails', params)
}
/**
 * 实名信息
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function getAuthenticationInfo(): Promise<any> {
  return await http.post('/api/member/authentication')
}
/**
 * 个人实名
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function addSaveInfo({ username = '', card_id = '' }): Promise<any> {
  return await http.post('/api/member/saveinfo', { username, card_id })
}
/**
 * 企业实名
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function addEnterpriseSaveInfo({ enterprise_name = '', enterprise_code = '', corporate_tel = '', imgs = '' }): Promise<any> {
  return await http.post('/api/member/save_enterprise', { enterprise_name, enterprise_code, corporate_tel, imgs })
}
/**
 * 企业实名上传营业执照
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function addEnterpriseSaveUploadimg({ file = '' }): Promise<any> {
  return await http.post('/index/member/uploadimg', file)
}
/**
 * 我的图库编辑名称
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function updateTuku({ tuku_id = '', name = '', new_name = '' }): Promise<any> {
  return await http.post('/index.php?route=vapi/design/renameFile', { tuku_id, name })
}

/** 
 * 我的图库重命名文件夹操作
 * @export
 * @param folder_id 文件夹ID
 * @param folder_name 文件夹新名称
 */
export async function renameFolder(body: { folder_id: number, folder_name: string }): Promise<any> {
  return http.post('/index.php?route=vapi/design/renameFolder', body);
}
/** 
 * 我的图库移动文件夹操作
 * @export
 * @param folder_id 文件夹ID
 * @param sort 移动方向, `'up'`表示向上移动, `'down'`表示向下移动
 */
export async function proImgsSort(body: { folder_id: number, sort: 'up' | 'down' }): Promise<any> {
  return http.post('/index.php?route=vapi/design/proImgsSort', body);
}

/** 
 * 我的图库删除文件夹操作
 * @export
 * @param folder_id 文件夹ID
 */
export async function deleteFolder(folder_id: number): Promise<any> {
  return http.post('/index.php?route=vapi/design/deleteFolder', { folder_id });
}


/**
 * 我的图库删除操作
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function delTuku({ act = '', folder_id = '', tuku_id = '' }): Promise<any> {
  const body: Record<string, unknown> = { act }
  if (folder_id !== '' && folder_id !== undefined && folder_id !== null) body.folder_id = folder_id
  if (tuku_id !== '' && tuku_id !== undefined && tuku_id !== null) body.tuku_id = tuku_id
  return await http.post('/index.php?route=vapi/design/deleteFile', body)
}
/**
 * 我的图库
 * @export
 * @param {Object} params -page
 */
export async function getMyTuku({
  page = 1,
  key = '',
  time = '',
  folder_id = NaN,
  pagesize = 10,
  ai_description = 0,
  ai_tag = 0
}) {
  return await http.post('/index.php?route=vapi/design/getDesignIcon', {
    page,
    key,
    time,
    folder_id,
    pagesize,
    ai_description,
    ai_tag
  });
}

export async function getFolder({ key = '', time = '', parent_folder_id = '' }) {
  return await http.post('/index.php?route=vapi/design/getFolder', { key, time, parent_folder_id });
}


export async function getMyTuku1({ page = 1, txt = '' }) {
  return await http.post('/index.php?route=apipc/diy/getdesignIcon', { page, txt });
}
/**
 * 我的图库上传文件
 * @export
 * @param {Object} params -page
 */
export async function designUploadImg({ file = [], tags = '', title = '', folder_id = '' }: { file?: any; tags?: string; title?: string; folder_id?: string | number } = {}) {
  return await http.post('/index.php?route=apipc/diy/design_uploadimg', file);
}

export async function addFolder({ folder_name = '', parent_folder_id = 0 }): Promise<any> {
  return await http.post('/index.php?route=vapi/design/addFolder', { folder_name, parent_folder_id })
}

/**
* 购物车提交数据
* @export
* @param {Object} [params] - 
* @returns
*/
export async function addCartData({ formData = {} }): Promise<any> {
  return await http.post('/index.php?route=vapi/carts/cart_procode', formData);
}
/**
* 手动推单
* @export
* @param {Object} [params] - 
* @returns
*/
export async function handPushOrder({ file = '' }): Promise<any> {
  return await http.post('/index.php?route=vapi/order_push/handPushOrder', file);
}
/**
* 产品报缺
* @export
* @param {Object} [params] - 
* @returns
*/
export async function productBaoque({ lan_id = '', is_dubug = 1 }): Promise<any> {
  return await http.post('/api/order/product_baoque', { lan_id, is_dubug });
}
/**
* 商品热卖推荐，新品速递
* @export
* @param {Object} [params] - 
* @returns
*/
export async function getHotProduct({ type = '', limit = 10 }): Promise<any> {
  return await http.post('/index.php?route=vapi/index/getProHot', { type, limit });
}
/**
* 常见问题帮助
* @export
* @param {Object} [params] - 
* @returns
*/
export async function getHelp(): Promise<any> {
  return await http.post('/index.php?route=vapi/index/getHelp');
}
/**
* 首页统计数据、基本数据
* @export
* @param {Object} [params] - 
* @returns
*/
export async function getIndexInfo(): Promise<any> {
  return await http.post('/index.php?route=vapi/index/getInfo');
}
/**
* 订单 / 商品统计数据
* @export
* @param {Object} params - 
* @param {number} params.source - 统计来源 2:商品销售 4:订单统计
* @param {number} params.type - 统计类型 1:今日 2:本周 3:本月
* @param {number} [params.source_from=2]
* @param {number} [params.order_from=1]
* @param {number} [params.ziuid]
* @returns
*/
export async function getOrderStatistics({
  source,
  type,
  source_from,
  order_from,
  ziuid,
}: {
  source: number,
  type: number,
  source_from?: number,
  order_from?: number,
  ziuid?: number,
}): Promise<any> {
  const payload: any = {
    source,
    type,
  }
  if (source_from !== undefined) payload.source_from = source_from
  if (order_from !== undefined) payload.order_from = order_from
  // 只有当 ziuid 有值时才添加到 payload 中
  if (ziuid !== undefined && ziuid !== null) {
    payload.ziuid = ziuid
  }
  return await http.post('/index.php?route=vapi/index/getOrderStatisticsData', payload);
}
/**
* 订单来源列表
* @export
* @param {Object} [params] - 
* @returns
*/
export async function getOrderSource(): Promise<any> {
  return await http.post('/index.php?route=vapi/index/getOrderSource');
}

/**
* 获取个人统计数据
* @export
* @param {Object} params
* @param {number|string} [params.ziuid]
* @param {number|string} [params.source]
* @param {string} [params.start_time]
* @param {string} [params.end_time]
* @param {number|string} [params.order_from]
* @param {number|string} [params.source_from]
* @returns
*/
export async function getPersonalStatistics({
  ziuid = '',
  source = '',
  start_time = '',
  end_time = '',
  order_from = '',
  source_from = '',
}: {
  ziuid?: number | string,
  source?: number | string,
  start_time?: string,
  end_time?: string,
  order_from?: number | string,
  source_from?: number | string,
} = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/index/getPersonalStatistics', {
    ziuid,
    source,
    start_time,
    end_time,
    order_from,
    source_from,
  });
}

/**
* 修改订单商品销售额
* @export
* @param {Object} params
* @param {number|string} params.order_product_id - 订单商品ID
* @param {number} params.money - 修改后的金额
* @returns
*/
export async function updateSalesMoney({
  order_product_id,
  money,
}: {
  order_product_id: number | string,
  money: number,
}): Promise<any> {
  return await http.post('/index.php?route=vapi/index/updateSalesMoney', {
    order_product_id,
    money,
  });
}

/**
* 平台授权
* @export
* @param {Object} [params] - 
* @returns
*/
export async function getAuthGetCode({ shop_id = '' }): Promise<any> {
  return await http.post('/index.php?route=vapi/shop/auth_get_code', { shop_id });
}
/**
* 下载生产图状态
* @export
* @param {Object} [params] - 
* @returns
*/
export async function getCreateImgStatu({ customer_design_id = '' }): Promise<any> {
  return await http.post('/index.php?route=vapi/product_img/create_img_status', { customer_design_id });
}
/**
* 下载生产图列表
* @export
* @param {Object} [params] - 
* @returns
*/
export async function getCreateImgList({ p = 1 }): Promise<any> {
  return await http.post('/index.php?route=vapi/product_img/create_img_list', { p });
}
/**
* 生成生产图
* @export
* @param {Object} [params] - 
* @returns
*/
export async function createProductionImgs({ this_rid = [] }): Promise<any> {
  return await http.post('/index/online/create_production_imgs', this_rid);
}
/**
* 我的成品信息
* @export
* @param {Object} [params] - 
* @returns
*/
export async function getDesiginRecord({ this_rid = '', pid = '', act = '' }): Promise<any> {
  const formData = new FormData();
  formData.append('pid', pid);
  formData.append('this_rid', this_rid);
  formData.append('act', act);
  return await http.post('/index.php?route=vapi/product_img/design_record', formData);
}
/**
* 单个生产图列表
* @export
* @param {Object} [params] - 
* @returns
*/
export async function getProductionImgResult({ this_rid = '' }): Promise<any> {
  const formData = new FormData();
  formData.append('this_rid', this_rid);
  return await http.post('/index.php?route=vapi/product_img/production_img_result', formData);
}
/**
* 单个生产图生成
* @export
* @param {Object} [params] - 
* @returns
*/
export async function createProductionImg({ this_rid = '', pid = '', can = {}, is_2d = '' }): Promise<any> {
  const formData = new FormData();
  formData.append('this_rid', this_rid);
  if (is_2d) {
    formData.append('is_2d', is_2d);
  }
  formData.append('pid', pid);
  formData.append('can', JSON.stringify(can));
  return await http.post('/index.php?route=vapi/product_img/create_production_img', formData);
}
/**
* 订单管理-待确认-生产图提交
* @export
* @param {Object} [params] - 
* @returns
*/
export async function createProductionImgByoid({ oid = '' }): Promise<any> {
  return await http.post('/index.php?route=vapi/product_img/create_production_img_byoid', { oid });
}
/**
* 购物车加减数量
* @export
* @param {Object} [params] - 
* @returns
*/
export async function caoNumCart({ cid = '', num = 0 }): Promise<any> {
  return await http.post('/index.php?route=vapi/carts/update', { cid, type: 2, num });
}
//购物车、结算删除pdf
export async function deletePdf(params: any): Promise<any> {
  return await http.post('/index.php?route=vapi/carts/deletePdf', params);
}
/**
* 订单管理-备注
* @export
* @param {Object} [params] - 
* @returns
*/
export async function orderMark({ oid = '', ordermark = '' }): Promise<any> {
  return await http.post('/index.php?route=vapi/order/ordermarkset', { oid, ordermark });
}
/**
* 订单管理-工厂备注
* @export
* @param {Object} [params] - 
* @returns
*/
export async function factory_Mark({ oid = '', factory_remark = '' }): Promise<any> {
  return await http.post('/index.php?route=vapi/order/factoryRemark', { oid, factory_remark });
}

/**
 * 订单管理-修改地址
 * @param form 
 * @returns 
 */
export async function changeAddress(form: { aid: number | string, order_id: number | string }): Promise<any> {
  return http.post('/index.php?route=vapi/order/changeAddress', form);
}

/**
 * 订单管理-添加成品
 * @param form 
 * @returns 
 */
export async function addOrderProduct(form: Required<AddProductData>): Promise<any> {
  return http.post('/index.php?route=vapi/order_product/addOrderProduct', form);
}
/**
* 订单管理-商品备注
* @export
* @param {Object} [params] - 
* @returns
*/
export async function factoryProduct({ order_product_id = '', otherid = '', good_remark = '' }): Promise<any> {
  return await http.post('/index.php?route=vapi/order/saveGoodRemark', { order_product_id, otherid, good_remark });
}
/**
* 订单管理-标记备货
* @export
* @param {Object} [params] - 
* @returns
*/
export async function changeStockUp({ order_id = '', stock_up = '' }): Promise<any> {
  return await http.post('/index.php?route=vapi/order/changeStockUp', { order_id, stock_up });
}
/**
* 订单管理-更新预计发货时间
* @export
* @param {Object} [params] - 
* @returns
*/
export async function updateExpectedDeliveryTime({ order_id = '', expected_delivery_time = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/order/updateExpectedDeliveryTime', { order_id, expected_delivery_time });
}
/**
* 订单管理-获取定位
* @export
* @param {Object} [params] - 
* @returns
*/
export async function getHandxy({ sku = '', size = '', buliao = '' }): Promise<any> {
  return await http.post('/index.php?route=vapi/order_push/gethandxy', { sku, size, buliao });
}
/**
* 订单管理-拆分
* @export
* @param {Object} [params] - 
* @returns
*/
export async function orderSplit({ otherid = '', splitarr = '' }): Promise<any> {
  return await http.post('/api/order/ordersplit', { otherid, splitarr });
}

/**
* 订单管理-拆分
* @export
* @param {Object} [params] - 
* @returns
*/
export async function splitOrder(form: { order_id: string | number, other_id: string | number, split_data: AddProductData[] }): Promise<any> {
  return await http.post('/index.php?route=vapi/order_product/splitOrder', form);
}

/**
* 订单管理-复制
* @export
* @param {Object} [params] - 
* @returns
*/
export async function orderCopy({ otherid = '' }): Promise<any> {
  return await http.post('/index.php?route=vapi/order/ordercopy', { otherid });
}
/**
* 订单管理-改成品ID
* @export
* @param {Object} [params] - 
* @returns
*/
export async function changeSkuId({ otherid = '', newskuid = '', type = 1 }): Promise<any> {
  return await http.post('/index.php?route=vapi/order/changeskuid', { otherid, newskuid, type });
}
/**
* 上传pdf
*/
export async function uploadPdf({ orderid = '', filecode = '' }): Promise<any> {
  return await http.post('/index.php?route=vapi/order/uploadPdf', { orderid, filecode });
}
/**
* 我的商品-获取2D图片
* @export
* @param {Object} [params] - 
* @returns
*/
export async function getModelImages({ did = '' }): Promise<any> {
  return await http.post('/index/online/get_model', { did });
}
/**
* 我的商品-商家
* @export
* @param {Object} [params] - 
* @returns
*/
export async function getFactory(): Promise<any> {
  return await http.post('/index.php?route=vapi/order/getfactory');
}
/**
* 我的商品-恢复搁置
* @export
* @param {Object} [params] - 
* @returns
*/
export async function orderReturn({ orderid = '' }): Promise<any> {
  return await http.post('/index.php?route=vapi/order/orderreturn', { orderid });
}
/**
* 我的商品-返回设计
* @export
* @param {Object} [params] - 
* @returns
*/
export async function backToDesign({ orderid = '', otherid = '' }): Promise<any> {
  return await http.post('/index.php?route=vapi/order/backtodesign', { orderid, otherid });
}
/**
* 我的商品-删除订单
* @export
* @param {Object} [params] - 
* @returns
*/
export async function orderDelone({ otherid = '' }): Promise<any> {
  return await http.post('/index.php?route=vapi/order/orderdelone', { otherid });
}
/**
* 购物车-检测登录
* @export
* @param {Object} [params] - 
* @returns
*/
export async function checkIsLogin(): Promise<any> {
  return await http.post('/index/index/checkislogin');
}
/**
* 刊登-添加属性
* @export
* @param {Object} [params] - 
* @returns
*/
export async function attributeAdd({ code = '', is_display = 1, is_require = 0, module = '', name = '', platform = '', product_type = '', status = 0, values = '' }): Promise<any> {
  return await http.post('/api/Attribute/add', { code, is_display, is_require, module, name, platform, product_type, status, values });
}
/**
 * 刊登-查询属性
 * @export
 * @param {Object} [params] - 
 * @returns
 */
export async function getAttributeAll(): Promise<any> {
  return await http.get('/api/attribute/all');
}
/**
 * 刊登-删除属性
 * @export
 * @param {Object} [params] - 
 * @returns
 */
export async function deleteAttribute({ id = '' }): Promise<any> {
  return await http.post('/api/attribute/delete', { id });
}
/**
* 刊登-修改属性
* @export
* @param {Object} [params] - 
* @returns
*/
export async function attributeUpdate({ id = '', code = '', is_display = 1, is_require = 0, module = '', name = '', platform = '', product_type = '', status = 0, values = '' }): Promise<any> {
  return await http.post('/api/Attribute/update', { id, code, is_display, is_require, module, name, platform, product_type, status, values });
}
/**
 * 刊登-查询产品标题规则模板
 * @export
 * @param {Object} [params] - 
 * @returns
 */
export async function getProductTitleAll({ name = '', start_time = '', end_time = '' }): Promise<any> {
  return await http.post('/api/product_name_rules/all', { name, start_time, end_time });
}

/**
 * 刊登-删除标题模板
 * @export
 * @param {Object} [params] - 
 * @returns
 */
export async function deleteProductRules({ id = '' }): Promise<any> {
  return await http.post('/api/product_name_rules/delete', { id });
}
/**
 * 刊登-添加产品标题规则模板
 * @export
 * @param {Object} [params] - 
 * @returns
 */
export async function addProductRules({ name = '', rules = '' }): Promise<any> {
  return await http.post('/api/product_name_rules/add', { name, rules });
}
/**
 * 刊登-修改产品标题规则模板
 * @export
 * @param {Object} [params] - 
 * @returns
 */
export async function updateProductTitleAll({ name = '', id = '', rules = '' }): Promise<any> {
  return await http.post('/api/product_name_rules/update', { name, id, rules });
}


/**
 * 刊登-查询sku规则模板
 * @export
 * @param {Object} [params] - 
 * @returns
 */
export async function getSkuAll({ name = '', start_time = '', end_time = '' }): Promise<any> {
  return await http.post('/api/product_sku_rules/all', { name, start_time, end_time });
}

/**
 * 刊登-删除sku模板
 * @export
 * @param {Object} [params] - 
 * @returns
 */
export async function deleteSkuRules({ id = '' }): Promise<any> {
  return await http.post('/api/product_sku_rules/delete', { id });
}
/**
 * 刊登-添加sku规则模板
 * @export
 * @param {Object} [params] - 
 * @returns
 */
export async function addSkuRules({ name = '', parent_rule = '', child_rule = '', simple_rule = '' }): Promise<any> {
  return await http.post('/api/product_sku_rules/add', { name, parent_rule, child_rule, simple_rule });
}
/**
 * 刊登-修改sku规则模板
 * @export
 * @param {Object} [params] - 
 * @returns
 */
export async function updateSkuAll({ name = '', id = '', parent_rule = '', child_rule = '', simple_rule = '' }): Promise<any> {
  return await http.post('/api/product_sku_rules/update', { name, id, parent_rule, child_rule, simple_rule });
}

/**
 * 刊登-查询关键词组
 * @export
 * @param {Object} [params] - 
 * @returns
 */
export async function getKeywordsAll(): Promise<any> {
  return await http.post('/api/product_keywords/all');
}

/**
 * 刊登-删除关键词组
 * @export
 * @param {Object} [params] - 
 * @returns
 */
export async function deleteKeywordsRules({ id = '' }): Promise<any> {
  return await http.post('/api/product_keywords/delete', { id });
}
/**
 * 刊登-添加关键词组
 * @export
 * @param {Object} [params] - 
 * @returns
 */
export async function addKeywordsRules({ name = '', parent = 0 }): Promise<any> {
  return await http.post('/api/product_keywords/add', { name, parent });
}
/**
 * 刊登-修改关键词组
 * @export
 * @param {Object} [params] - 
 * @returns
 */
export async function updateKeywordsAll({ name = '', id = '', content = '' }): Promise<any> {
  return await http.post('api/product_keywords/update', { name, id, content });
}

/**
 * 刊登-查询条形码
 * @export
 * @param {Object} [params] - 
 * @returns
 */
export async function getGtinsAll({ generate_type = 0 }): Promise<any> {
  return await http.post('/api/product_gtins/gtins', { generate_type });
}

/**
 * 刊登-改变条形码状态
 * @export
 * @param {Object} [params] - 
 * @returns
 */
export async function changeGtins({ ids = '', status = 0 }): Promise<any> {
  return await http.post('/api/product_gtins/changeGtinsStatus', { ids, status });
}
/**
 * 刊登-添加条形码
 * @export
 * @param {Object} [params] - 
 * @returns
 */
export async function addGtins({ generate_type = 0, type = 0, content = '' }): Promise<any> {
  return await http.post('/api/product_gtins/add', { generate_type, type, content });
}
/**
 * 刊登-查询条形码详情
 * @export
 * @param {Object} [params] - 
 * @returns
 */
export async function getGtinsDetailAll({ generate_type = 0, gtin_id = 0, keyword = '', status = 0 }): Promise<any> {
  return await http.post('/api/product_gtins/gtins', { generate_type, gtin_id, keyword, status });
}
/**
 * 刊登-改变条形码详情状态
 * @export
 * @param {Object} [params] - 
 * @returns
 */
export async function changeGtinsDetail({ ids = '', status = 0, gtin_id = 0 }): Promise<any> {
  return await http.post('/api/product_gtins/changeGtinsStatus', { ids, status, gtin_id });
}
/**
 * 1.材质渲染下拉框带搜索接口
 * @param {Object} [params] - 
 */
export async function tuidanCans({ model = '' }): Promise<any> {
  return await http.post('/index.php?route=vapi/order_push/getGuige', { model })
}
/**
 * 2.款号渲染下拉框带搜索接口
 * @param {Object} [params] - 
 */
export async function tuidanStyles({ keyword = '' }): Promise<any> {
  return await http.post('/index.php?route=vapi/order_push/styles', { keyword })
}

/**
* 公共获取函数
* @export
* @param {Object} [params] - 
* @returns
*/
export async function getCommonInfo(params: any): Promise<any> {
  const { url, ...newParams } = params;
  return await http.post(url, newParams);
}
/**
* 获取svg函数
* @export
* @param {Object} [params] - 
* @returns
*/
export async function getSvgInfo(params: any): Promise<any> {
  const { url, ...newParams } = params;
  return await http.get(url, newParams);
}

/**
 * 获取默认地址
 * @param {Object} [params] -
*/
export async function getDefaultAddress({ type = '' }): Promise<any> {
  return await http.post('/index.php?route=vapi/checkout/getDefaultAddress', { type })
}

/**
 * 设置默认地址
 * @param {Object} [params] -
*/
export async function setDefaultAddress({ type = '', id = 0 }): Promise<any> {
  return await http.post('/index.php?route=vapi/checkout/setDefaultAddress', { type, id })
}


/**
 * 获取支付方式
 * @param {Object} [params] -
 */
export async function getPaymentMethod(): Promise<any> {
  return await http.post('/index.php?route=vapi/checkout/payMethod', {})
}

export async function getPaymentMethod1(): Promise<any> {
  return await http.post('/index.php?route=vapi/checkout/payMethod', {})
}

/**
 * 待付款支付
 *
*/
export async function unpaidPaymentNew({ order_id = '', payment_method = '' }): Promise<any> {
  return await http.post('/index.php?route=vapi/order/unpaidPaymentNew', { order_id, payment_method })
}

export async function isOrderPaid({ order_id = '' }): Promise<any> {
  return await http.post('/index.php?route=extension/payment/wechat_pay/isOrderPaid', { order_id })
}

/**
 * 订单确定的商品列表
 * @export
 * @param {Object} params -
 * @returns
 */
export async function getCheckoutCartList() {
  return await http.post('/index.php/?route=vapi/checkout/getCartList', {});
}

export async function getCheckoutCartListNew() {
  return await http.post('/index.php/?route=vapi/checkout/getCartListNew', {});
}

/**
 * 订单确定
 * @export
 * @param {Object} params -
 * @returns
 */
export async function createOrder(formData: any) {
  return await http.post('/index.php/?route=vapi/checkout/confirm', formData);
}


/**
 * 验证订单
 * @export
 * @param {Object} params -
 * @returns
 */
export async function checkoutOrder() {
  return await http.post('/index.php/?route=vapi/checkout/index');
}


/**
 * 获取优惠券信息
 * @export
 * @param {Object} params -
 * @returns
 */
export async function getTotalSection() {
  return await http.post('/index.php/?route=vapi/checkout/getTotalSection');
}


//更新订单
export async function updateCheckOrder(formData: any) {
  return await http.post('/index.php/?route=vapi/checkout/update', formData);
}

export async function getPickupList() {
  return await http.post('/index.php/?route=vapi/checkout/getPickupList');
}
export async function selectTotals({ orderId = '' }) {
  return await http.post('/index.php?route=vapi/order/selectTotals', { orderId });
}

export async function getRemark({ cid = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/design/getRemark', { cid })
}

export async function updateRemark({ cid = '', remark = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/design/updateRemark', { cid, remark })
}

export async function getShippingMethodsNewTwo() {
  return await http.post('/index.php?route=vapi/order/getShippingMethodsNewTwo');
}


/**
 * 获取第三方平台
 */
export async function listStorePlatforms(): Promise<any> {
  return await http.get('/index.php?route=customer/store/listStoreTypes')
}

/**
 * 获取店铺列表
 */

export async function listStores(params: any): Promise<any> {
  return await http.post('/index.php?route=customer/store/listStores', params);
}

/**
 * 获取店铺详情
 */

export async function getStoreInfo(params: any): Promise<any> {
  return await http.post('/index.php?route=customer/store/storeInfo', params);
}

/**
 * 新增/编辑产品模板，获取店铺列表
 */

export async function listStoresByProductTemplate(params: any): Promise<any> {
  return await http.post('/index.php?route=customer/store/listStoresByProductTemplate', params);
}


/**
 * 保存店铺
 */
export async function storeSave(formData: any): Promise<any> {
  return await http.post('/index.php?route=customer/store/save', formData)
}

/**
* 获取平台授权url
* @export
* @param {Object} [params] - 
* @returns
*/
export async function getStoreAuthUrl(params: any): Promise<any> {
  return await http.post('/index.php?route=customer/store/authUrl', params);
}

/**
* 刷新token
* @export
* @param {Object} [params] - 
* @returns
*/
export async function refreshOauthToken(params: any): Promise<any> {
  return await http.post('/index.php?route=customer/store/refreshOauthToken', params);
}


/**
* 删除店铺
* @export
* @param {Object} [params] - 
* @returns
*/
export async function storeDelete(params: any): Promise<any> {
  return await http.post('/index.php?route=customer/store/storeDelete', params);
}


/**
* 获取产品分类
* @export
* @param {Object} [params] - 
* @returns
*/
export async function getCategoriesByPlatformId(params: any): Promise<any> {
  return await http.post('/index.php?route=customer/store/listCategoryByPlatformId', params);
}

/**
 * 获取 Shopify 分类
 */
export async function getShopifyCategorys(params: any): Promise<any> {
  return await http.post('/index.php?route=customer/shopify/getShopifyCategorys', params);
}

/**
* 获取产品分类
* @export
* @param {Object} [params] - 
* @returns
*/
export async function getProductSchemaByCategoryId(params: any): Promise<{
  code: number,
  msg: string,
  data: {
    category_type: string,
    chooseAllQualifySpec: boolean,
    inputMaxSpecNum: 2,
    parentSpec: ParentSpec[],
    properties: ProductSchemaTemu[]
    // attributes: ProductSchemaTikTok[]
  }
}> {
  return http.post('/index.php?route=customer/store/getProductSchemaByCategoryId', params);
}


/**
* 保存上品模板
* @export
* @param {Object} [params] - 
* @returns
*/
export async function platformTemplateSave(params: any): Promise<any> {
  return await http.post('/index.php?route=customer/store/platformTemplateSave', params);
}

/**
* 保存上品模板
* @export
* @param {Object} [params] - 
* @returns
*/
export async function platformTemplateEdit(params: any): Promise<any> {
  return await http.post('/index.php?route=customer/store/platformTemplateEdit', params);
}


/**
* 获取上品模板
* @export
* @param {Object} [params] - 
* @returns
*/
export async function listPlatformTemplates(params: any): Promise<any> {
  return await http.post('/index.php?route=customer/store/listPlatformTemplates', params);
}

/**
* 删除模板
* @export
* @param {Object} [params] - 
* @returns
*/
export async function deletePlatformTemplate(params: any): Promise<any> {
  return await http.post('/index.php?route=customer/store/deletePlatformTemplate', params);
}
/**
* 获取上品模板详情
* @export
* @param {Object} [params] - 
* @returns
*/
export async function getTemplateDetail(params: { templateId: number, cid: number }): Promise<any> {
  return await http.post('/index.php?route=customer/store/getTemplateDetail', params);
}

/**
* 获取上品模板信息
* @export
* @param {Object} [params] - 
* @returns
*/
export async function getPlatformTemplateInfo(params: any): Promise<any> {
  return await http.post('/index.php?route=customer/store/getPlatformTemplateInfo', params);
}

/**
* 获取上品商品SKU、价格详情
* @export
* @param {Object} [params] - 
* @returns
*/
export async function getStoreProductDetail(params: { cid: number }): Promise<any> {
  return await http.post('/index.php?route=customer/store/getStoreProductDetail', params);
}


/**
* 保存刊登商品
* @export
* @param {Object} [params] - 
* @returns
*/
export async function saveAsinProduct(params: any): Promise<any> {
  return await http.post('/index.php?route=customer/store/saveAsinProduct', params);
}

/**
* 无产品保存刊登商品
* @export
* @param {Object} [params] - 
* @returns
*/
export async function savePublishProduct(params: any): Promise<any> {
  return await http.post('/index.php?route=customer/store/savePublishProduct', params);
}

/**
* 编辑刊登商品
* @export
* @param {Object} [params] - 
* @returns
*/
export async function editAsinProduct(params: any): Promise<any> {
  return await http.post('/index.php?route=customer/store/editAsinProduct', params);
}


/**
* 获取刊登商品列表
* @export
* @param {Object} [params] - 
* @returns
*/
export async function listAsinProducts(params: any): Promise<any> {
  return await http.post('/index.php?route=customer/store/listAsinProducts', params);
}



/**
* 获取刊登商品列表
* @export
* @param {Object} [params] - 
* @returns
*/
export async function asinProductDelete(params: any): Promise<any> {
  return await http.post('/index.php?route=customer/store/asinProductDelete', params);
}


/**
* 刊登商品
* @export
* @param {Object} [params] - 
* @returns
*/
export async function publishProduct(params: any): Promise<any> {
  return await http.post('/index.php?route=customer/store/publishProduct', params);
}

/**
 * 上传图片
 * @export
 * @param {Object} [params] - 
 * @param {string} [params.type] - product user step
 * @returns
 */
export async function uploadCustomerFile(params: any) {

  const formData = new FormData();
  formData.append('file', params.file);

  try {
    const response = await axios.post('/index.php?route=customer/store/uploadFile', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error('上传图片失败:', error);
    throw error;
  }
}

/**
 * 上传视频
 * @export
 * @param {Object} [params] - 
 * @param {File} [params.file] - 视频文件
 * @param {number} [params.storeId] - 店铺ID
 * @returns
 */
export async function uploadVideo(params: any) {
  const formData = new FormData();
  formData.append('file', params.file);

  try {
    const response = await axios.post(`/index.php?route=customer/store/uploadVideo&store_id=${params.storeId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error('上传视频失败:', error);
    throw error;
  }
}

/**
* 获取阿里店铺的视频列表
* @export
* @param {Object} [params] - 
* @returns
*/
export async function storeVideoCenterList(params: any): Promise<any> {
  return await http.post('/index.php?route=customer/store/storeVideoCenterList', params);
}


/**
* 获取tenu店铺的尺码列表
* @export
* @param {Object} [params] - 
* @returns
*/
export async function storeSizeTemplateList(params: any): Promise<any> {
  return await http.post('/index.php?route=customer/store/storeSizeTemplateList', params);
}

/**
* 获取tenu店铺的模特列表
* @export
* @param {Object} [params] - 
* @returns
*/
export async function storeGoodsModelList(params: any): Promise<any> {
  return await http.post('/index.php?route=customer/store/storeGoodsModelList', params);
}


/**
* 获取阿里店铺的自定义分类
* @export
* @param {Object} [params] - 
* @returns
*/
export async function userAliCategoryList(params: any): Promise<any> {
  return await http.post('/index.php?route=customer/store/userAliCategoryList', params);
}

/**
* 创建temu尺码表
* @export
* @param {Object} [params] - 
* @returns
*/
export async function createGoodsSizecharts(params: any): Promise<any> {
  return await http.post('/index.php?route=customer/store/createGoodsSizecharts', params);
}
/**
* 效果细节图数组，删除图片
* @export
* @param {Object} [params] - 
* @returns
*/
export async function picOtherNameDel({ customer_design_id = '', pic_other_name_key = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/design/picOtherNameDel', { customer_design_id, pic_other_name_key });
}
/**
 * 排序
 * @export
 * @param {Object} [params] -
 * @returns
 */
export async function customerDesignPageSort({ customer_design_id = '', sort = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/design/customerDesignPageSort', { customer_design_id, sort });
}
/**
* 效果细节图数组，添加图片
* @export
* @param {Object} [params] - 
* @returns
*/
export async function picOtherNameAdd({ customer_design_id = '', other_effect_img_json_one = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/design/picOtherNameAdd', { customer_design_id, other_effect_img_json_one });
}
/**
* 效果细节图数组，上传图片
* @export
* @param {Object} [params] - 
* @returns
*/
export async function picOtherNameAddImg(formData: FormData): Promise<any> {
  return await http.post('/index.php?route=vapi/design/picOtherNameAddImg', formData);
}

/**
 * 共享成品
 *
*/
export async function shareDesign({ design_id = '', act = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/design/shareDesign', { design_id, act });
}


export async function collectOfficialDesign({ design_id = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/design/collectOfficialDesign', { design_id });
}
/**
 * 取消收藏
 * @param param
 * @returns 
 */
export async function cancelOfficialCollect({ design_id = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/design/cancelCollect', { design_id });
}

/**
 * 官方成品
 * @export
 * @param {Object} [params]
 */
export async function officialDesign({ page = 1, key = '', cat = '', category = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/design/officialDesign', { page, key, cat, category })
}

/**
* 获取tiktok的仓库列表
* @export
* @param {Object} [params] -
* @returns
*/
export async function getTiktokWarehouses(params: any): Promise<any> {
  return await http.post('/index.php?route=customer/store/getTiktokWarehouses', params);
}


export async function getNewDesign(): Promise<any> {
  return await http.post('/index.php?route=vapi/design/getNewDesign')
}

/**
 * 商品列表加入购物车
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function clickProductToCart({ pid = '', num = 1, cid = '', code = '', can = {}, attribute = '', token = '', is_paynow = 0 } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/design/addCartNew', { pid, num, cid, code, can, attribute, token, is_paynow })
}

/**
* 获取tiktok全球商品详情
* @export
* @param {Object} [params] - 
* @returns
*/
export async function getGlobalProduct(params: any): Promise<any> {
  return await http.post('/index.php?route=customer/store/getTiktokGlobalProduct', params);
}

/**
* 发布tiktok全球商品到站点
* @export
* @param {Object} [params] - 
* @returns
*/
export async function publishTiktokGlobalProduct(params: any): Promise<any> {
  return await http.post('/index.php?route=customer/store/publishTiktokGlobalProduct', params);
}

/**
* lazada视频上传
* @export
* @param {Object} [params] - 
* @returns
*/
export async function lazadaCreateVideo(params: any): Promise<any> {
  return await http.post('/index.php?route=customer/store/lazadaCreateVideo', params);
}


/**
* 获取虾皮产品分类
* @export
* @param {Object} [params] - 
* @returns
*/
export async function getShopeeCategory(params: any): Promise<any> {
  return await http.post('/index.php?route=customer/store/getShopeeCategory', params);
}

/**
* 获取Shopee商品物流渠道
* @export
* @param {Object} [params] -
* @returns
*/
export async function getShopeeLogisticsChannels(params: any): Promise<any> {
  return await http.post('/index.php?route=customer/store/getShopeeLogisticsChannels', params);
}

/**
* 获取Shopee全球商品详情
* @export
* @param {Object} [params] - 
* @returns
*/
export async function getShopeeGlobalProduct(params: any): Promise<any> {
  return await http.post('/index.php?route=customer/store/getShopeeGlobalProduct', params);
}

/**
* 获取Shopee全球商品发布店铺
* @export
* @param {Object} [params] - 
* @returns
*/
export async function getShopeePublishableShops(params: any): Promise<any> {
  return await http.post('/index.php?route=customer/store/getShopeePublishableShops', params);
}


/**
* 发布shopee全球商品到站点
* @export
* @param {Object} [params] - 
* @returns
*/
export async function publishShopeeGlobalProduct(params: any): Promise<any> {
  return await http.post('/index.php?route=customer/store/publishShopeeGlobalProduct', params);
}

/**
* 获取成品详情
* @export
* @param {Object} [params] - 
* @returns
*/
export async function getAsProductInfo(params: any): Promise<any> {
  return await http.post('/index.php?route=customer/store/getAsProductInfo', params);
}


/**
* 获取成品刊登记录
* @export
* @param {Object} [params] - 
* @returns
*/
export async function getAsinProductTaskLog(params: any): Promise<any> {
  return await http.post('/index.php?route=customer/store/getAsinProductTaskLog', params);
}


/**
* 更新购物车订单销售价格
* @export
* @param {Object} [params] - 
* @returns
*/
export async function saveOrderSalePrice(params: any): Promise<any> {
  return await http.post('/index.php?route=vapi/order/saveOrderSalePrice', params);
}



/**
 * 速卖通确认接单
 * @export
 * @param {Object} [params]
 * @param {integer} [params.orderid]
 * @param {integer} [params.type] 1余额支付 2支付宝支付
 * @param {string} [params.token]
 */
export async function aliexpressCurchaseOrder({ orderid = '', token = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/order/aliexpressCurchaseOrder', { orderid, token })
}
/**
* 获取阿里店铺的自定义分类
* @export
* @param {Object} [params] - 
* @returns
*/
export async function storeGoodsAccessories(params: any): Promise<any> {
  return await http.post('/index.php?route=customer/store/storeGoodsAccessories', params);
}

/**
 * 获取订单导入模板
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function getImportTemplate({ } = {}): Promise<any> {
  return await http.get('/index.php?route=vapi/import/prod_drawing/getImportTemplate', {})
}
/**
 * 上传订单导入表格
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function uploadExcel({ file = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/import/prod_drawing/uploadExcel', { file })
}
/**
 * 导入订单
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function importOrder_item({ import_id = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/import/prod_drawing/importOrder', { import_id })
}
/**
 * 获取订单导入记录
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function getImportRecords({ page = '' } = {}): Promise<any> {
  return await http.get('/index.php?route=vapi/import/prod_drawing/getImportRecords', { params: { page } })
}
/**
 * 订单导入前验证是否已导入过
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function importOrderCheck({ original_name = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/order/importOrderCheck', { original_name })
}
/**
 * 订单导出
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function getexportOrder({ token = '', order_ids = '' } = {}): Promise<any> {
  return await http.get('/index.php?route=vapi/order/exportOrder', { params: { token, order_ids } })
}
/**
 * 获取订单商品详情、查看订单生产流程
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function getProductDetail({ token = '', page = '', limit = '', order_id = '', finish_type = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/product/getProductDetail', { token, page, limit, order_id, finish_type })
}
/**
 * 获取订单生产进度 
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function getProductStatus({ token = '', page = '', limit = '', order_id = '', finish_type = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/product/getProductStatus', { token, page, limit, order_id, finish_type })
}
/**
 * 我的素材 批量移动至文件夹
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function imgToFolder(folder_id: number, ...tuku_ids: number[]): Promise<any> {
  const tuku_id = join(tuku_ids, ',');
  return http.post('/index.php?route=vapi/design/imgToFolder', { tuku_id, folder_id })
}
/**
 * 获获素材图片、我的素材 批量操作
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function imgBatchUpdate({
  tuku_id = Array<number>(),
  folder_id = Array<number>(),
  tags = Array<String>(),
  title = Array<String>()
}): Promise<any> {
  return await http.post('/index.php?route=vapi/design/imgBatchUpdate', { tuku_id, folder_id, tags, title });
}
/**
 * 获获素材图片、我的素材获取所有标签
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function getTagsAll({ } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/design/getTagsAll', {})
}
/**
 * 验证提取状态
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function getDescripcheck({ ids = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=customer/ai_image_recognition/check', { ids })
}
/**
 * 批量提取素材图片描述 
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function getDescription({ ids = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=customer/ai_image_recognition/getDescription', { ids })
}
/**
 * 修改AI描述
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function updateDescription({ id = '', description_cn = '', description_en = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=customer/ai_image_recognition/updateDescription', { id, description_cn, description_en })
}
/**
 *清除AI描述
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function cleanDescription({ id = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=customer/ai_image_recognition/cleanDescription', { id })
}
/**
 * 删除AI标签
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function tagDel({ id = '', tag = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=customer/ai_image_recognition/tagDel', { id, tag })
}
/**
 *批量提取素材标签
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function getTags({ ids = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=customer/ai_image_recognition/getTags', { ids })
}
/**
 * 订单管理 shopee添加获取面单
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function createPdf({ order_source = '', orderid = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/order/createPdf', { order_source, orderid })
}
/**
 *temu订单获取发货仓库   
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function getTemuMallAddress({ order_source = '', orderids = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=customer/order/getTemuMallAddress', { order_source, orderids })
}
/**
 *temu订单创建发货单
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function temuCreateShiporder({ order_source = '', orderids = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=customer/order/temuCreateShiporder', { order_source, orderids })
}
/**
 *获取第三方物流公司
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function temuLogisticsList({ order_source = '', orderids = '', deliveryAddressId = '', subWarehouseId = '', deliveryOrderSn = '', totalPackageNum = '', predictTotalPackageWeight = '', receiveAddressInfo = {} } = {}): Promise<any> {
  return await http.post('/index.php?route=customer/order/temuLogisticsList', { order_source, orderids, deliveryAddressId, subWarehouseId, deliveryOrderSn, totalPackageNum, predictTotalPackageWeight, receiveAddressInfo })
}
/**
 * 装箱发货
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function temuShiporderPackingSend({ deliveryOrderSns = '', deliveryContactNumber = '', predictTotalPackageWeight = '', pickupDate = '', order_source = '', orderids = '', deliveryAddressId = '', deliverMethod = '', expressCompanyId = '', expressCompanyName = '', totalPackageNum = '', driverName = '', plateNumber = '', subWarehouseId = '', predictId = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=customer/order/temuShiporderPackingSend', { deliveryOrderSns, deliveryContactNumber, predictTotalPackageWeight, pickupDate, order_source, orderids, deliveryAddressId, deliverMethod, expressCompanyId, expressCompanyName, totalPackageNum, driverName, plateNumber, subWarehouseId, predictId })
}

/**
 * 修改订单商品条码
 * @export
 * 
 */
export async function saveOrderProductCode(sku_code: string, product_code: string, order_product_id: string) {
  return await http.post('/index.php?route=vapi/order/saveProductCode', { sku_code, product_code, order_product_id });
}

/**
 * 修改商品条码
 * @param sku_code 
 * @param product_code 
 * @param order_product_id 
 * @returns 
 */
export async function saveOtherProductCode(sku_code: string, product_code: string, otherid: string) {
  return http.post('/index.php?route=vapi/order/saveProductCode', { sku_code, product_code, otherid });
}
/**
 * 订单管理：待设计状态
 * @param sku 
 * @returns 
 */
export async function checkSkuExists(sku: any,) {
  return http.post('/index.php?route=vapi/design/checkSkuExists', { sku });
}
/**
 * 订单管理：批量取消订单
 * @param orderids 
 * @returns 
 */
export async function batchCancel({ orderids = '', } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/order/batchCancel', { orderids })
}
/**
 * 6、查询发货单信息
 * @param orderids 
 * @returns 
 */
export async function getTemuShiporders({ orderids = '', order_source = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=customer/order/getTemuShiporders', { orderids, order_source })
}
/**
 * 订单管理：上传订单PDF
 * @param orderids 
 * @returns 
 */
export async function uploadOrderPdf({ file = '', order_id = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/upload_pdf/uploadOrderPdf', { file, order_id })
}
/**
 * 订单管理：上传订单商品PDF
 * @param orderids 
 * @returns 
 */
export async function uploadOrderProductPdf({ file = '', order_id = '', order_product_id = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/upload_pdf/uploadOrderProductPdf', { file, order_id, order_product_id })
}
/**
 * 订单管理：删除订单PDF或订单商品PDF
 * @param orderids 
 * @returns 
 */
export async function upload_pdfdelPdf(params: any): Promise<any> {
  return await http.post('/index.php?route=vapi/upload_pdf/delPdf', params)
}
/**
 * 订单管理：手动推单
 * @param orderids 
 * @returns 
 */
export async function getHandLastRecord({ sku = '' }): Promise<any> {
  return await http.post('/index.php?route=vapi/order_push/getHandLastRecord', { sku })
}
/**
 * 我的成品 产品列表图片获取
 * @param orderids 
 * @returns 
 */
export async function getPicOtherName({ cid = '' }): Promise<any> {
  return await http.post('/index.php?route=apipc/v1/diy/getPicOtherName', { cid })
}
/**
 * 半托管-查询运费模板列表
 * @param orderids 
 * @returns 
 */
export async function getLogisticsTemplateList({ storeId = 0, siteId = [] as any }): Promise<any> {
  return await http.post('/index.php?route=customer/temu/getLogisticsTemplateList', { storeId, siteId })
}
/**
 * 半托管-查询可绑定的发货仓库信息
 * @param orderids 
 * @returns 
 */
export async function getWarehouseList({ storeId = 0, siteId = [] as any }): Promise<any> {
  return await http.post('/index.php?route=customer/temu/getWarehouseList', { storeId, siteId })
}
/**
 * 订单管理 temu新增创建发货台
 * @param orderids 
 * @returns 
 */
export async function addShiporderStaging({ order_source = '', orderids = '', deliveryAddressId = '', deliveryAddressLabel = '' }): Promise<any> {
  return await http.post('/index.php?route=customer/order/addShiporderStaging', { order_source, orderids, deliveryAddressId, deliveryAddressLabel })
}
/**
 * 订单管理 手动同步订单
 * @param orderids 
 * @returns 
 */
export async function syncOrder({ platform = '' }): Promise<any> {
  return await http.post('/index.php?route=customer/order/syncOrder', { platform })
}
/**
 * 商品列表
 * @export
 * @param {string} [params.cid] - 商品ID
 * @param {string} [params.page] - 分页参数
 * @param {string} [params.product_name] - 商品名称
 * @param {string} [params.customer_id] - 客户ID
 * @param {number} [params.editionnum] - 版本号
 * @param {string} [params.origin] - 来源
 * @param {number} [params.store_id] - 店铺ID
 * @returns
 */
export async function getProductList({ cid = '', customer_id = '', editionnum = 1, origin = '', page = 1, product_name = '', store_id = 0 } = {}): Promise<any> {
  return await http.post('/index.php?route=apipc/v1/diy/productList', { cid, customer_id, editionnum, origin, page, product_name, store_id });
}

/**
 * 获取店铺视频中心列表
 * @param {number} storeId - 店铺ID
 * @param {number} page - 页码
 * @param {number} pageSize - 每页数量
 * @returns
 */
export async function getStoreVideoCenterList(storeId: number, page: number = 1, pageSize: number = 20): Promise<any> {
  return await http.post('/index.php?route=customer/store/storeVideoCenterList', { storeId, page, pageSize });
}

/**
 * 获取商品尺码列表
 * @param {number} pid - 商品ID
 * @returns
 */
export async function getDesignCart(pid: number): Promise<any> {
  return await http.post('/index.php?route=vapi/design/designCart', { pid });
}
/**
 * @returns 
 */
export async function getAllSize() {
  return await http.get('/index.php?route=customer/publish/getSizes', {});
}
/**
 * 获取商品分类
 * @param pid 
 * @returns 
 */
export async function getProductCategory(page: number, product_id: number, store_id: string, customer_id: string, origin: string): Promise<any> {
  return await http.post('/index.php?route=apipc/v1/diy/indexInit', { page, product_id, store_id, customer_id, origin });
}
/**
 * 我的成品 搜索素材
 * @param orderids 
 * @returns 
 */
export async function getProImgs({ key = '', page = 1 }): Promise<any> {
  return await http.post('/index.php?route=vapi/design/getProImgs', { key, page })
}
/**
 * 我的成品 添加分类
 * @param orderids 
 * @returns 
 */
export async function addCategory({ cate_name = '' }): Promise<any> {
  return await http.post('/index.php?route=design/cate/add', { cate_name })
}
/**
 * 我的成品 删除分类
 * @param orderids 
 * @returns 
 */
export async function deleteCategory({ cate_id = '' }): Promise<any> {
  return await http.post('/index.php?route=design/cate/delete', { cate_id })
}
/**
 * 我的成品 修改分类
 * @param orderids 
 * @returns 
 */
export async function amendCategory({ cate_name = '', cate_id = '' }): Promise<any> {
  return await http.post('/index.php?route=design/cate/add', { cate_name, cate_id })
}
/**
 * 我的成品 获取分类列表
 * @param orderids 
 * @returns 
 */
export async function getListCategory() {
  return await http.get('/index.php?route=design/cate/getList', {});
}
/**
 * 我的成品 移动到成品分类
 * @param orderids 
 * @returns 
 */
export async function removeCategory({ page_ids = '', cate_id = '' }): Promise<any> {
  return await http.post('/index.php?route=design/cate/removeCate', { page_ids, cate_id })
}
/**
 * 获取子账号列表
 * @param orderids 
 * @returns 
 */
export async function getZiAccountList({ }): Promise<any> {
  return await http.post('/index.php?route=customer/fenfa/getZiAccountList', {})
}
/**
 * 店铺管理 店铺分发
 * @param orderids 
 * @returns 
 */
export async function addStoreFenfa({ zi_account_id = '', type = '', store_name = '', store_id = '', platformId = '' }): Promise<any> {
  return await http.post('/index.php?route=customer/fenfa/addStoreFenfa', { zi_account_id, type, store_name, store_id, platformId })
}
/**
 * 店铺管理 店铺已分发记录
 * @param orderids 
 * @returns 
 */
export async function getStoreFenfaLogs({ type = '', store_id = '', platformId = '' }): Promise<any> {
  return await http.post('/index.php?route=customer/fenfa/getStoreFenfaLogs', { type, store_id, platformId })
}
/**
 * 店铺管理 取消分发订单
 * @param orderids 
 * @returns 
 */
export async function cancelStoreFenfa({ type = '', store_id = '', platformId = '' }): Promise<any> {
  return await http.post('/index.php?route=customer/fenfa/cancelStoreFenfa', { type, store_id, platformId })
}
/**
 * 订单管理 分发订单
 * @param orderids 
 * @returns 
 */
export async function addOrderFenfa({ zi_account_id = '', orderIds = '', }): Promise<any> {
  return await http.post('/index.php?route=customer/fenfa/addOrderFenfa', { zi_account_id, orderIds })
}
/**
 * 订单管理 取消订单
 * @param orderids 
 * @returns 
 */
export async function cancelOrderFenfa({ orderIds = '', }): Promise<any> {
  return await http.post('/index.php?route=customer/fenfa/cancelOrderFenfa', { orderIds })
}
/**
 * 站内消息系统 获取分类和未读数量
 * @param orderids 
 * @returns 
 */
export async function unreadCount(): Promise<any> {
  return await http.get('/index.php?route=customer/message/unreadCount');
}
/**
 * 站内消息系统 获取消息列表
 * @param orderids 
 * @returns 
 */
export async function messageList({ page = '', page_size = '', unread = '', category_id = '', start_time = '', end_time = '', keyword = '' }) {
  return await http.get('/index.php?route=customer/message/messageList', { params: { page, page_size, unread, category_id, start_time, end_time, keyword } })
}
/**
 * 站内消息系统 获取消息详情
 * @param orderids 
 * @returns 
 */
export async function messagedetail({ id = '' }): Promise<any> {
  return await http.get('/index.php?route=customer/message/detail', { params: { id } })
}
/**
 * 站内消息系统 设置所有消息已读
 * @param orderids 
 * @returns 
 */
export async function messagereadAll(): Promise<any> {
  return await http.get('/index.php?route=customer/message/readAll')
}
/**
 * 站内消息系统  每次刷新页面请求的全局弹窗消息
 * @param orderids 
 * @returns 
 */
export async function tipMessageList(): Promise<any> {
  return await http.get('/index.php?route=customer/message/tipMessageList')
}
/**
 * 站内消息系统  设置消息不再提醒
 * @param orderids 
 * @returns 
 */
export async function dontShowForever({ message_id = '', }): Promise<any> {
  return await http.post('/index.php?route=customer/message/dontShowForever', { message_id })
}
/**
 * 站内消息系统  获取订阅管理列表
 * @param orderids 
 * @returns 
 */
export async function subscriptions(): Promise<any> {
  return await http.get('/index.php?route=customer/message/subscriptions')
}
/**
 * 站内消息系统  修改订阅状态
 * @param orderids 
 * @returns 
 */
export async function updateSubscription({ id = '', category_id = '', subscribe = '' }): Promise<any> {
  return await http.post('/index.php?route=customer/message/updateSubscription', { id, category_id, subscribe })
}
/**
 * Y2物流对接 获取物流仓列表
 * @param orderids 
 * @returns 
 */
export async function getItsWarehouseList({ }): Promise<any> {
  return await http.get('/index.php?route=customer/temusemi/getItsWarehouseList', { params: {} })
}
/**
 * Y2物流对接 获取temu完整物流提供商
 * @param orderids 
 * @returns 
 */
export async function getLogisticsCompanies({ store_id = '' }): Promise<any> {
  return await http.get('/index.php?route=customer/temusemi/getLogisticsCompanies', { params: { store_id } })
}
/**
 * Y2物流对接 获取temu完整物流提供商
 * @param orderids 
 * @returns 
 */
export async function getLogisticsWarehouseList({ store_id = '' }): Promise<any> {
  return await http.get('/index.php?route=customer/temusemi/getLogisticsWarehouseList', { params: { store_id } })
}
/**
 * Y2物流对接  保存物流映射
 * @param orderids 
 * @returns 
 */
export async function saveWarehouseMapping(params: any): Promise<any> {
  return await http.post('/index.php?route=customer/temusemi/saveWarehouseMapping', params)
}
/**
 * Y2物流对接 获取已经保存的映射
 * @param orderids 
 * @returns 
 */
export async function warehouseMappings({ store_id = '' }): Promise<any> {
  return await http.get('/index.php?route=customer/temusemi/warehouseMappings', { params: { store_id } })
}
/**
 * 订单管理 申请运单号 获取Y2发货仓对应的物流列表
 * @param orderids 
 * @returns 
 */
export async function orderWarehouse({ order_ids = '' }): Promise<any> {
  return await http.post('/index.php?route=customer/temusemi/orderWarehouse', { order_ids })
}
/**
 * 订单管理 申请运单号 申请Y2订单发货单
 * @param orderids 
 * @returns 
 */
export async function applyShipping(params: any): Promise<any> {
  return await http.post('/index.php?route=customer/temusemi/applyShipping', params)
}
/**
 * 订单管理 申请运单号 获取订单对应的物流仓库
 * @param orderids 
 * @returns 
 */
export async function getShippingservices({ orderid = '', warehouseId = '', weight = '', weightUnit = '', length = '', width = '', height = '', dimensionUnit = '' }): Promise<any> {
  return await http.post('/index.php?route=customer/temusemi/getShippingservices', { orderid, warehouseId, weight, weightUnit, length, width, height, dimensionUnit })
}
/**
 * 订单管理 申请运单号 获取订单对应的发货信息
 * @param orderids 
 * @returns 
 */
export async function queryOrderInfos({ order_ids = '', warehouseId = '' }): Promise<any> {
  return await http.post('/index.php?route=customer/temusemi/queryOrderInfos', { order_ids, warehouseId })
}
/**
 * 订单管理 待确认 单个付款和批量付款
 * @param orderids 
 * @returns 
 */
export async function getShippingMethods({ order_id = '' }): Promise<any> {
  return await http.post('/index.php?route=vapi/order/getShippingMethods', { order_id })
}
/**
 * 订单管理 待确认 Y2付款
 * @param orderids 
 * @returns 
 */
export async function getShippingy({ order_id = '' }): Promise<any> {
  return await http.post('/index.php?route=customer/temusemi/getShippingMethods', { order_id })
}
/**
 * 订单管理 退货/退款
 * @param orderids 
 * @returns 
 */
export async function getOrderProducts({ order_id = '' }): Promise<any> {
  return await http.post('/index.php?route=vapi/return/getOrderProducts', { order_id })
}
/**
 * 订单管理 退货/退款 原因
 * @param orderids 
 * @returns 
 */
export async function getReturnReason({ }): Promise<any> {
  return await http.get('/index.php?route=vapi/return/getReturnReason', { params: {} })
}
/**
 * 订单管理 退货/退款 原因 确认接口
 * @param orderids 
 * @returns 
 */
export async function refundParams(params: any) {
  return await http.post('/index.php?route=vapi/return/tuiOrder', params);
}
/**
 * 我的成品 批量加入购物车
 * @param orderids 
 * @returns 
 */
export async function batchChoothDesign(params: any) {
  return await http.post('/index.php?route=vapi/design/batchChoothDesign', params);
}
/**
 * 购物车 快速添加
 * @param orderids 
 * @returns 
 */
export async function getSkuPage(params: any) {
  return await http.post('/index.php?route=vapi/design/getSkuPage', params);
}
/**
 * 订单管理 待设计图片显示
 * @param orderids 
 * @returns 
 */
export async function getYiSheJj({ order_id = '', other_id = '', order_product_id = '' }): Promise<any> {
  return await http.post('/index.php?route=vapi/order/getYiSheJj', { order_id, other_id, order_product_id })
}

/**
 * AI相关接口
 * 获取ai绘图记录
 * &zi_account_id=0&design_id=0&page=1&page_size=10&has_design=1&type=0
 */
export async function getAiDrawRecord({ zi_account_id = 0, page = 1, page_size = 10, has_design = 1, type = 0, keyword = '' } = {}) {
  return await http.get('/api?route=/customer/ai_drawing/logs', { params: { zi_account_id, page, page_size, has_design, type, keyword } })
}

/**获取其他主题 */
export async function getSimilarDesign({ page = 1, key = '', pid = '' } = {}) {
  return await http.post('/index.php?route=vapi/design/similarDesign', { page, key, pid })
}

/**获取相似素材 */
export async function getOtherDesign({ page = 1, key = '', kuan_num = '', customer_design_id = '' } = {}) {
  return await http.post('/index.php?route=vapi/design/otherDesign', { page, key, kuan_num, customer_design_id })
}

/**获取详情 */
export async function getProDetail({ pid = 0 } = {}) {
  return await http.post('/index.php?route=apipc/diy/getpro', { pid })
}
/**
 * 订单管理 退货/退款 详情
 * @param orderids 
 * @returns 
 */
export async function getReturnDetails({ order_id = '' }): Promise<any> {
  return await http.post('/index.php?route=vapi/return/getReturnDetails', { order_id })
}
/**
 * 订单管理 取消退款
 * @param orderids 
 * @returns 
 */
export async function cancelTuiOrder({ order_id = '' }): Promise<any> {
  return await http.post('/index.php?route=vapi/return/cancelTuiOrder', { order_id })
}
/**
 * 订单管理 Tiktok全托管 创建送货单
 * @param orderids 
 * @returns 
 */
export async function deliveryTkgbOrders({ orderids = '' }): Promise<any> {
  return await http.post('/index.php?route=customer/order/deliveryTkgbOrders', { orderids })
}

/**
 * 订单管理 Tiktok全托管 送货单列表查询
 * @param orderids 
 * @returns 
 */
export async function tkGbDeliveryOrdersSearch({ orderids = '' }): Promise<any> {
  return await http.post('/index.php?route=customer/order/tkGbDeliveryOrdersSearch', { orderids })
}
/**
 * 订单管理 Tiktok全托管 商家地址列表查询
 * @param orderids 
 * @returns 
 */
export async function tkGbSupplierAddresses({ orderids = '' }): Promise<any> {
  return await http.post('/index.php?route=customer/order/tkGbSupplierAddresses', { orderids })
}
/**
 * 订单管理 Tiktok全托管 可用物流商与预约日期查询
 * @param orderids 
 * @returns 
 */
export async function tkGbShippingProviders(params: any) {
  return await http.post('/index.php?route=customer/order/tkGbShippingProviders', params);
}
/**
 * 订单管理 Tiktok全托管 预约发货
 * @param orderids 
 * @returns 
 */
export async function tkGbReserveShip(params: any) {
  return await http.post('/index.php?route=customer/order/tkGbReserveShip', params);
}
/**
 * 订单管理 Tiktok 虚假发货
 * @param orderids 
 * @returns 
 */
export async function shipPackages({ orderids = '' }): Promise<any> {
  return await http.post('/index.php?route=customer/tiktok/shipPackages', { orderids })
}
/**
 * Y2物流对接 获取物流商
 * @param orderids 
 * @returns 
 */
export async function getLogisticsProvider({ store_id = '' }): Promise<any> {
  return await http.get('/index.php?route=customer/temusemi/getLogisticsProvider', { params: { store_id } })
}
/**
 * Y2物流对接 获取物流商
 * @param orderids 
 * @returns 
 */
export async function getItsWarehouse({ store_id = '', code = '', type = '' }): Promise<any> {
  return await http.get('/index.php?route=customer/temusemi/getItsWarehouseList', { params: { store_id, code, type } })
}
/**
 * Y2物流对接 修改物流商配置
 * @param orderids 
 * @returns 
 */
export async function updateLogisticsProvider({ store_id = '', code = '', type = '', status = '', app_key = '' }): Promise<any> {
  return await http.post('/index.php?route=customer/temusemi/updateLogisticsProvider', { store_id, code, type, status, app_key })
}
/**
 * tiktok全托管 确认送货
 * @param orderids 
 * @returns 
 */
export async function tkGbDeliveryConfirm({ orderids = '' }): Promise<any> {
  return await http.post('/index.php?route=customer/order/tkGbDeliveryConfirm', { orderids })
}

/**
 * 获取产品分类名称
 * @param  
 * @returns 
 */
export async function getGroupProduct({ page = 1, key = '', cat = '', category = '' }): Promise<any> {
  return await http.post('/index.php?route=vapi/design/getGroupProduct', { page, key, cat, category })
}
/**
 * 获取产品分类名称
 * @param  
 * @returns 
 */
export async function getGroupName({ page = 1, key = '', cat = '', category = '' }): Promise<any> {
  return await http.post('/index.php?route=vapi/design/getGroupName', { page, key, cat, category })
}
/**
 * 刊登：获取站点列表
 * @param orderids 
 * @returns 
 */
export async function sites({ }): Promise<any> {
  return await http.get('/index.php?route=customer/temusemi/sites', { params: {} })
}
/**
 * 刊登 一键批量汇出 保存
 * @param orderids 
 * @returns 
 */
export async function saveAsinProductBatch(params: any): Promise<any> {
  return await http.post('/index.php?route=customer/store/saveAsinProductBatch', params)
}
/**
 * 订单：待设计 上传素材
 */
export async function order_design_material(params: {
  file: File;
  order_id: string | number;
  sku_code: string | number;
}) {
  const formData = new FormData();
  formData.append('file', params.file);
  formData.append('order_id', String(params.order_id));
  formData.append('sku_code', String(params.sku_code));
  return await http.post('/index.php?route=vapi/order_design_material/upload', formData);
}
/**
 * 订单：待设计 导出素材压缩包
 */
export async function getMaterialZip(params: any): Promise<any> {
  return await http.post('/index.php?route=vapi/order_design_material/getMaterialZip', params)
}
/**
 * 订单：待设计 获取上传素材列表
 * @export
 * @param {Object} [params]
 */
export async function materialList({ order_id = '', sku_code = '' }): Promise<any> {
  return await http.get('/index.php?route=vapi/order_design_material/materialList', { params: { order_id, sku_code } })
}
/**
 * 订单：待设计 获取上传素材 删除
 * @export
 * @param {Object} [params]
 */
export async function order_design_delete({ material_id = '', }): Promise<any> {
  return await http.post('/index.php?route=vapi/order_design_material/delete', { material_id })
}
/**
 * 充值：银行卡转账信息获取
 * @export
 * @param {Object} [params]
 */
export async function payment_bank(): Promise<any> {
  return await http.get('/index.php?route=api/payment/bank');
}
/**
 * 订单：顺丰物流重新获取面单
 * @export
 * @param {Object} [params]
 */
export async function sfglobal_createOrder({ order_ids = '', }): Promise<any> {
  return await http.post('/index.php?route=customer/sfglobal/createOrder', { order_ids })
}
/**
 * 订单：云途物流重新获取面单
 * @export
 * @param {Object} [params]
 */
export async function yunexpress_createOrder({ order_ids = '', }): Promise<any> {
  return await http.post('/index.php?route=customer/yunexpress/createOrder', { order_ids })
}
/**
 * 订单：递四方物流重新获取面单
 * @export
 * @param {Object} [params]
 */
export async function shipping_detail_createOrder({ order_ids = '', }): Promise<any> {
  return await http.post('/index.php?route=customer/shipping_detail/createOrder', { order_ids })
}
/**
 * 订单：tiktok直邮店 获取订单对应的可选物流方式
 * @export
 * @param {Object} [params]
 */
export async function getShippingProviders(params: any = {}): Promise<any> {
  const { orderids = '' } = params
  return await http.post('/index.php?route=customer/tiktok/getShippingProviders', { orderids })
}
/**
 * 订单：tiktok直邮店虚拟发货
 * @export
 * @param {Object} [params]
 */
export async function markPackageShipped(params: any) {
  return await http.post('/index.php?route=customer/tiktok/markPackageShipped', params);
}
/**
 * 订单：批量重新获取面单
 * @export
 * @param {Object} [params]
 */
export async function reapplyShipping({ order_ids = '', }): Promise<any> {
  return await http.post('/index.php?route=customer/order/reapplyShipping', { order_ids })
}